import Vue from 'vue'
import Vuex from 'vuex'
import * as Api from './api.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    userinfo:{
      iscangku:false
    },
    qiyewxusername:'',
    },
  mutations: {
    setuserinfo(state,playload){
      state.userinfo = playload
    },
    setqiyeweixin(state,playload){
      state.qiyewxusername = playload
    },


  },
  actions: {
    getlocaluserinfo(context){
      console.log('getlocaluserinfo')
      var data = localStorage.getItem('userinfo');
      if (data){
        context.commit('setuserinfo',JSON.parse(data))
      }
    },
  }

})



// WEBPACK FOOTER //
// ./src/store/index.js